import { createSlice } from '@reduxjs/toolkit';
import { Views } from 'react-big-calendar';

export const calendarInitialState = {
  view: Views.MONTH,
  tasks: {
    list: [],
    fromDate: null,
    toDate: null,
    totalEntries: 0,
  },
  patrols: {
    list: [],
    fromDate: null,
    toDate: null,
    totalEntries: 0,
  },
  transport: {
    list: [],
    fromDate: null,
    toDate: null,
    totalEntries: 0,
  },
};

export const createSliceWithName = (name, initialState) =>
  createSlice({
    name,
    initialState,
    reducers: {
      fetchCalendarTaskEvents: () => {
        // action only for saga
      },
      fetchPatrolEvents: () => {
        // action only for saga
      },
      fetchTransportEvents: () => {
        // action only for saga
      },
      setCalendarEvents: (state, { payload }) => {
        const { list, taskType, totalEntries, fromDate, toDate } = payload;
        state[taskType] = {
          ...state[taskType],
          list,
          totalEntries,
          fromDate,
          toDate,
        };
      },
    },
  });
